import {TokenRequest} from "./request/TokenRequest";

export enum UserActionType {
    TOKENIZE = "TOKENIZE",
    UPDATE_TOKEN = "UPDATE_TOKEN",
    TOKENIZE_V1 = "TOKENIZE_V1",
    CHARGE_RETRIEVE = "CHARGE_RETRIEVE",
    PAYMENT_METHOD_RETRIEVE = "PAYMENT_METHOD_RETRIEVE",
    PAYMENT_METHOD_UPDATE = "PAYMENT_METHOD_UPDATE",
    CREATE_APPLE_PAY_SESSION = "CREATE_APPLE_PAY_SESSION",
    GET_MERCHANT_CONFIG = "GET_MERCHANT_CONFIG",
}

export interface UserActionCommonOptions {
    publicKey?: string
}

export interface UserActionChargeRetrieveOptions {
    clientObjectId: string
}

export interface UserActionPaymentMethodRetrieveOptions {
    clientObjectId: string
}

export interface UserActionPaymentMethodUpdateOptions {
    clientObjectId: string
    payload: string
}

export interface UserActionTokenizeOptions extends UserActionCommonOptions {
    data: TokenRequest
}

export interface UserActionTokenizeV1Options extends UserActionCommonOptions {
    request: any,
    publicKey: string
}

export interface UserActionCreateApplePaySessionOptions {
    validationUrl: string,
    merchantIdentifier: string
}

export interface UserActionUpdateTokenOptions {
    request: TokenRequest
    tokenId: string
}